import axios from "axios";

const request = axios.create({
  // 基础地址，对于非 http 和非 https 开头的请求都会在前面拼接上这个地址	
  baseURL: "/api/",
  // 超时时间，超过这个时间没有收到服务器的回复就会报错，单位是毫秒
  timeout: 20000,
  // 请求方式，默认是get，可以在这里设置默认方式为其他请求方式
  method: "post",
  //请求头配置
  headers: {},
})

request.interceptors.request.use(
  (config) => {
    if (config.url !== "/login") { // 判断请求是否是登录接口，或者判断token是否存在
      // 如果不是登录接口，就给请求头里面设置token
      // config.headers.token = sessionStorage.getItem("token");
    }
    const token = localStorage.getItem('sessionId');
    console.log('headers1', config.headers)
    if (token) {
      config.headers.Authorization = token; // 动态设置认证header
    }
    return config; // 返回这个配置对象，如果没有返回，这个请求就不会发送出去
  },
  (error) => {
    return Promise.reject(error);
  }
)

request.interceptors.response.use(
  (res) => {
    // 成功时返回数据
    let code = res.data.code
    console.log('response', res)
    if (code === 200) {
      return res.data.data
    } else {
      return res.data
    }
  },
  (error) => {
    // 失败时可以返回一些失败信息
    return Promise.reject(error);
  }
)

export default request;


// WEBPACK FOOTER //
// ./src/utils/request.js